import superjson from 'superjson';

// Recursively drop undefined values so superjson never has to encode them.
// Plain objects and arrays are walked; non-plain instances (Date, Map, Set,
// class instances, etc.) are passed through untouched so superjson can apply
// its own type-tagging.
const isPlainObject = (value: unknown): value is Record<string, unknown> => {
  if (value === null || typeof value !== 'object') return false;
  const proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null;
};

const stripUndefined = (value: unknown): unknown => {
  if (Array.isArray(value)) return value.map(stripUndefined);
  if (isPlainObject(value)) {
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(value)) {
      if (v === undefined) continue;
      out[k] = stripUndefined(v);
    }
    return out;
  }
  return value;
};

export const transformer = {
  serialize: (data: unknown) =>
    data === undefined
      ? { json: null }
      : superjson.serialize(stripUndefined(data)),
  deserialize: (data: unknown) =>
    superjson.deserialize(data as Parameters<typeof superjson.deserialize>[0]),
};
